/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeFilter {
    getFixupPrototypeFunction() { return ScopeFilter.fixupPrototype; }

    static newInstance(model: Partial<ScopeFilter>): ScopeFilter {
        let obj = Object.assign(new ScopeFilter(), model);
        ScopeFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeFilter>): ScopeFilter {
        if (!model) return null;
        return ScopeFilter.newInstance(<ScopeFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeFilter) {
        if (!obj) return;

        models.ScopeFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeFilter): boolean {
        Object.setPrototypeOf(obj, ScopeFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.regions) {
            for (let val of this.regions) {
                models.ScopeFilterRegion.fixupPrototype(val);
            }
        }
        if (this.resource_groups) {
            for (let val of this.resource_groups) {
                models.ScopeResourceGroup.fixupPrototype(val);
            }
        }
        if (this.zone) {
            for (let val of this.zone) {
                models.ScopeFilterZone.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of resource filter
     */
    scope: Array<string>;

    /**
     * List applicability filters of cloud account
     */
    applicability_by: Array<string>;

    /**
     * Get tags keys of cloud account
     */
    tag_keys: Array<string>;

    /**
     * List of regions of cloud account
     */
    regions: Array<models.ScopeFilterRegion>;

    /**
     * Get resource filters of cloud account
     */
    resources: Array<string>;

    /**
     * List of resource groups of cloud account
     */
    resource_groups: Array<models.ScopeResourceGroup>;

    /**
     * List zone of cloud account
     */
    zone: Array<models.ScopeFilterZone>;

}
